export const credentialManagementData = [
  {
    type: "sftp",
    name: "SFTP",
    fields: [
      { field: "host", label: "Host", type: "text", isRequired: true },
      { field: "portNumber", label: "Port number", type: "text", isRequired: true },
      { field: "username", label: "Username", type: "text", isRequired: true },
      { field: "password", label: "Password", type: "password", isRequired: true },
      { field: "sshKey", label: "SSH Key", type: "text", isRequired: false }
    ]
  },
  {
    type: "database",
    name: "Database",
    fields: [
      { field: "host", label: "Host", type: "text", isRequired: true },
      { field: "portNumber", label: "Port number", type: "text", isRequired: true },
      { field: "username", label: "Username", type: "text", isRequired: true },
      { field: "password", label: "Password", type: "password", isRequired: true },
      { field: "database", label: "Database", type: "text", isRequired: true }
    ]
  },
  {
    type: "smtp",
    name: "SMTP",
    fields: [
      { field: "host", label: "Host", type: "text", isRequired: true },
      { field: "portNumber", label: "Port number", type: "text", isRequired: true },
      { field: "username", label: "Username", type: "text", isRequired: true },
      { field: "password", label: "Password", type: "password", isRequired: true }
    ]
  },
  {
    type: "aws",
    name: "AWS Signature",
    fields: [
      { field: "region", label: "AWS Region", type: "text", isRequired: true },
      { field: "service", label: "Service Name", type: "text", isRequired: true },
      { field: "accessKey", label: "Access key", type: "text", isRequired: true },
      { field: "secretKey", label: "Secret key", type: "password", isRequired: true }
    ]
  },
  {
    type: "bearerToken",
    name: "Bearer Token",
    fields: [{ field: "token", label: "Token", type: "password", isRequired: true }]
  },
  {
    type: "basicAuth",
    name: "Basic Auth",
    fields: [
      { field: "username", label: "Username", type: "text", isRequired: true },
      { field: "password", label: "Password", type: "password", isRequired: true }
    ]
  },
  {
    type: "salesforce",
    name: "Salesforce Signature",
    fields: [
      { field: "authUrl", label: "Authentication URL", type: "text", isRequired: true },
      { field: "clientId", label: "Client ID", type: "text", isRequired: true },
      { field: "clientSecret", label: "Client Secret", type: "password", isRequired: true },
      { field: "username", label: "Username", type: "text", isRequired: true },
      { field: "password", label: "Password", type: "password", isRequired: true }
    ]
  },
  {
    type: "redis",
    name: "Redis",
    fields: [
      { field: "username", label: "Username", type: "text", isRequired: true },
      { field: "password", label: "Password", type: "password", isRequired: true },
      { field: "endpoint", label: "Endpoint", type: "text", isRequired: true },
      { field: "port", label: "Port", type: "text", isRequired: true }
    ]
  }
];
